import { AuthContext, useAuth } from 'context/AuthContext';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';

import { getChallengeHome, getChallengeUser } from 'services/challenges.service';
import { BsCheck } from 'react-icons/bs';
import Button from 'components/ui/button';

import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import Tippy from '@tippyjs/react';

export function Company() {
  const navigate = useNavigate();
  const { user, userInfo } = useAuth();

  const [homeChallenge, setHomeChallenge] = useState<any>([]);

  const [total, setTotal] = useState<number>();
  const [totalCompleted, setTotalCompleted] = useState<number>();

  const [totalGestor, setTotalGestor] = useState<number>();
  const [totalCompletedGestor, setTotalCompletedGestor] = useState<number>();

  const [totalRede, setTotalRede] = useState<number>(0);
  const [totalCompletedRede, setTotalCompletedRede] = useState<number>(0);

  const [optionsCycle, setOptionsCycle] = useState<any>();

  const { realCycle } = useContext(AuthContext);

  useEffect(() => {
    async function loadData() {
      if (userInfo?.chave) {
        const resp = await getChallengeHome();
        setHomeChallenge(resp);
        const data = await getChallengeUser();
        const _data = data.filter((item: any) => {
          if (item?.extra?.perfil === 'gestor' || item?.extra?.perfil === 'rede') return false;

          return true;
        });

        const __data = data.filter((item: any) => {
          if (item?.extra?.perfil !== 'gestor') return false;

          return true;
        });

        const ___data = data.filter((item: any) => {
          if (item?.extra?.perfil === 'rede') return true;

          return false;
        });

        const cycleOptions = realCycle
          ?.filter((item: any) => item.status === 'open')
          .map((cycle: any) => {
            cycle.label = 'Ciclo ' + cycle.title;
            cycle.value = cycle._id;

            return cycle;
          });

        if (cycleOptions && cycleOptions?.length > 0) {
          setOptionsCycle(cycleOptions[0]);
        }

        setTotalCompleted(_data.filter((item: any) => item.completed).length);
        setTotal(_data.length);

        setTotalCompletedGestor(__data.filter((item: any) => item.completed).length);
        setTotalGestor(__data.length);

        setTotalCompletedRede(___data.filter((item: any) => item.completed).length);
        setTotalRede(___data.length);
      }
    }

    if (userInfo && realCycle) {
      loadData();
    }
  }, [userInfo, realCycle]);

  function addBreakLine(str: string) {
    return str?.replace(/\n/g, '<br />');
  }

  const AcessibilityText = (cycleTxt: any) => {
    const [text, setText] = useState('');

    useEffect(() => {
      let txt = '';
      if (!!cycleTxt && !!cycleTxt.title) {
        if (cycleTxt.title.includes('2S')) {
          txt = cycleTxt.title.toLocaleLowerCase().replace('2s', 'Segundo semestre de ');
        }

        if (cycleTxt.title.includes('1s')) {
          txt = cycleTxt.title.toLocaleLowerCase().replace('1s', 'Primeiro semestre de ');
        }

        setText(txt);
      }
    }, [cycleTxt]);

    return (
      <span className="screen-reader-text" tabIndex={0}>
        {text}
      </span>
    );
  };

  return (
    <div className="flex flex-col">
      <>
        <div>
          {!user?.extra?.rede ? (
            <p className="text-white text-xs lg:text-sm block mb-6 font-thin" tabIndex={0}>
              Acompanhe aqui atividades extras disponíveis durante este ciclo, que podem gerar pontuação bônus para você.
            </p>
          ) : (
            <p className="text-white text-xs lg:text-sm block mb-2 font-thin" tabIndex={0}>
              Criamos 4 ações para você experimentar e conhecer a FLAP 360°.
            </p>
          )}

          {!user?.extra?.rede && (
            <p className="font-bold text-lg text-yellow mb-6">
              {optionsCycle?.label}

              <AcessibilityText {...optionsCycle} />
            </p>
          )}
        </div>

        <div className="flex flex-col lg:flex-row space-y-4 lg:space-y-0 items-center">
          <div className="bg-maastricht-blue rounded-lg px-5 py-3 text-sm md:w-[64%]">
            <p className="font-bold text-lg text-white mb-2" tabIndex={0}>
              Desafio mensal {optionsCycle?.title}
            </p>

            {/* <p className="font-thin">Em breve!</p> */}

            <p className="font-thin">
              Você realizou {totalCompleted}/{total} desafios disponíveis.
              <span className="screen-reader-text" tabIndex={0}>
                Você realizou {totalCompleted} de {total} desafios disponíveis
              </span>
            </p>

            {optionsCycle && optionsCycle?.date_end && optionsCycle?.date_start && (
              <p className="font-thin" tabIndex={0}>
                {`Prazo para cumprimento: ${format(new Date(optionsCycle.date_start), "dd 'de' MMMM", {
                  locale: ptBR,
                })} a ${format(new Date(optionsCycle.date_end), "dd 'de' MMMM 'de' yyyy", { locale: ptBR })}`}
              </p>
            )}
          </div>

          <div className="flex justify-center flex-1">
            <Button
              color="primary"
              className="uppercase py-2 text-sm  lg:-mr-8 min-w-[212px]"
              onClick={() => navigate('/desafios/jogador')}
              aria-label="Acessar lista de desafios deste ciclo"
            >
              ACESSAR DESAFIOS
            </Button>
          </div>
        </div>
      </>
    </div>
  );
}
